import { ParseKeys, TFunction } from "i18next";

import {
  AssetFinancialHoldingKind,
  AssetInventoryMissingFieldResponse,
  AssetPropertyRightKind,
} from "../../api/ClientFileApi";

export interface MissingFieldMessage {
  path: string;
  message?: string;
}

export type DescribeMissingField<TValues> = (
  field: AssetInventoryMissingFieldResponse,
  values: TValues,
  t: TFunction
) => MissingFieldMessage | undefined;

export function requiredMessage(t: TFunction, labelKey: ParseKeys): string {
  return t("common.validation.fieldRequired", { fieldName: t(labelKey) });
}

export function entriesMissing(path: string, t: TFunction): MissingFieldMessage {
  return { path, message: t("clients.client.debtSettlement.assetInventory.entriesMissing") };
}

export function itemFieldPath(
  collection: string,
  items: ReadonlyArray<{ id: string | null }>,
  field: AssetInventoryMissingFieldResponse
): string | undefined {
  const index = items.findIndex((item) => item.id !== null && item.id === field.itemId);
  return index < 0 ? undefined : `${collection}.${index}.${field.field}`;
}

export function itemField(
  collection: string,
  items: ReadonlyArray<{ id: string | null }>,
  field: AssetInventoryMissingFieldResponse
): MissingFieldMessage | undefined {
  const path = itemFieldPath(collection, items, field);
  return path ? { path } : undefined;
}

export const OWN_CLAIMS_ENTRIES_FIELD = "ownClaims";

export function financialHoldingsEntriesField(kind: AssetFinancialHoldingKind): string {
  return `financialHoldings.${kind}`;
}

export const TENANCY_ENTRIES_FIELD = `propertyRights.${AssetPropertyRightKind.Tenancy}`;
